import { useState, useEffect, useRef } from 'react';
import { Checkbox, Button, notification, Spin, Modal } from 'antd';
import RichText from 'components/RichText';
import { useHistory } from 'react-router';
import { getUserNoticeByIdApi } from 'api/userNotice';
const Notice = () => {
    const richTextRef = useRef(null);
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [imAgree, setImAgree] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const getUserNotice = () => {
        getUserNoticeByIdApi({ id: 1 }).then(res => {
            if (res.success) {
                richTextRef.current && richTextRef.current.setHtml(res.content);
                setLoading(false);
            }
        });
    };

    useEffect(() => {
        setIsModalOpen(true);
        getUserNotice();
    }, []);

    const onImAgreeChange = e => {
        const imAgree = e.target.checked;
        setImAgree(imAgree);
    };

    const goApply = () => {
        if (imAgree) {
            history.push('/userApply/assessment');
        } else {
            notification.warning({
                message: '请认真阅读申请须知，并勾选“我已阅读申请须知”',
            });
        }
    };
    return (
        <div>
            <Spin spinning={loading}>
                <RichText
                    defaultValue={'正在获取入住须知...'} // 初始值
                    disabled={true} // 是否禁用
                    ref={richTextRef}
                />
                <div style={{ margin: '15px 20px' }}>
                    <Checkbox checked={imAgree} onChange={onImAgreeChange}>
                        <span style={{ color: '#f00' }}>我已阅读申请须知</span>
                    </Checkbox>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <Button type="primary" onClick={goApply}>
                        开始填写评估表
                    </Button>
                </div>
            </Spin>
            <Modal title="Basic Modal" open={isModalOpen}>
                <span>测试谁是谁</span>
            </Modal>
        </div>
    );
};
export default Notice;
